import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Button,
    Heading,
    Text,
    useColorModeValue,
    Textarea,
    Select,
    Spinner,
  } from '@chakra-ui/react';
  import { FormEvent, useCallback, useState } from 'react';
  import { CheckCircleIcon, CloseIcon} from '@chakra-ui/icons';

import { Shippment, updateShippRequest, updateUserResponse } from '../../../shared';
import {CHARGE_STATES, STATES} from '../types'
import { getCaptinsLocally } from '../fetch/captins';
import { isAdmin, isCaptin, isLoggedIn } from '../fetch/auth';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../routes';
import { ApiError, callEndpoint } from '../fetch';
import { ENDPOINT_CONFIGS } from '../endpoints';

  export default function UpdateShippCard({shipp}:{shipp: Shippment | null}) {
    const navigate = useNavigate();
    const [shippId] = useState(!shipp? "" : shipp.id);
    const [captinId, setCaptinId] = useState(!shipp? "" : shipp.captinId);
    const [fees, setFees] = useState(!shipp? 0 : shipp.fees);
    const [shippState, setShippState] = useState(!shipp? 0 : shipp.state);
    const [chargeState, setChargeState] = useState(!shipp? 0 : shipp.chargeState);
    const [execNotes, setExcNotes] = useState(!shipp? '_' : shipp.execNotes);
    const [excDate, setExcDate] = useState(!shipp? new Date() : new Date(shipp.excuteTime));
    const [resOk,setResOk]=useState(false);
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);
    const captins= getCaptinsLocally();
    

    
      const handleSubmit = useCallback(
        async (e: FormEvent | MouseEvent) => {
          e.preventDefault();
     
          setBusy(true);
          if (!isLoggedIn() || !(isAdmin()||isCaptin())) {
            navigate(ROUTES.SIGN_IN);
          }
          setResOk(false);
          try {
  
          await callEndpoint<updateShippRequest, updateUserResponse>( ENDPOINT_CONFIGS.updateShipp , {
              id:shippId,
              captinId:captinId,
              fees:fees,
              state:shippState,
              excuteTime:new Date(excDate).getTime(),
              chargeState:chargeState,
              execNotes:execNotes
            });
        
            setResOk(true);
            setError('');
            setBusy(false);
           // navigate(ROUTES.HOME);
          } catch (e) {        
            setError((e as ApiError).message);
            setBusy(false);
          }
        },
        [shippId, captinId,fees,shippState,excDate,chargeState,execNotes]
      );

 
      function onChangeDate(date:string){
     

        let today=Number(new Date()) 
        var msPerDay = 86400 * 1000;
var beginning = shipp?.excuteTime! - (shipp?.excuteTime! % msPerDay);
         if(new Date(date).getTime() > today || new Date(date).getTime() < beginning){
             setExcDate(new Date(today));
             alert('تاريخ خاطئ');
             return
         }
         setExcDate(new Date(date));
       }
      
    return (

      <form onSubmit={handleSubmit} dir='rtl'>
         <fieldset disabled={busy}>
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}>
        <Stack spacing={8} w={'full'} mx={'auto'} maxW={'lg'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'} textAlign={'center'}>
              تحديث الطرد
            </Heading>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
            
            <FormControl id="id">
                <FormLabel>الرقم</FormLabel>
                <Input isDisabled type="text" value={shipp?.id}/>
              </FormControl>

              <FormControl id="desc">
                <FormLabel>محتوى الطرد</FormLabel>
                <Input isDisabled type="text" value={shipp?.description}/>
              </FormControl>

              <FormControl id="adress">
                <FormLabel>عنوان المستلم</FormLabel>
                <Textarea isDisabled value={shipp?.addrees}/>
              </FormControl>
              
              <FormControl id="recivedesc">
                <FormLabel>وصف المرتجع</FormLabel>
                <Input isDisabled type={'text'}  value={shipp?.receiveDesc}/>
              </FormControl>

              <FormControl id="charge">
                <FormLabel>القيمة</FormLabel>
                <Input isDisabled type="number" value={shipp?.charge}/>
              </FormControl>

              <FormControl id="fees" isRequired>
                <FormLabel>الرسوم</FormLabel>
                <Input isDisabled={isCaptin()} type={'number'} value={fees} onChange={e => setFees(Number(e.target.value))} onFocus={e => e.target.select()}/>
              </FormControl>

             {/* <FormControl id="state" >
                <FormLabel>State</FormLabel>
                <Select  value={States[shippState]} onChange={e => onChangeState(e.target.value)} > 
               <option>{States[0]}</option>
               <option>{States[1]}</option>
               <option>{States[2]}</option>
               <option>{States[3]}</option>
               <option>{States[4]}</option>
                 </Select>   
    </FormControl>*/}


              <FormControl id="state" >
                <FormLabel>الحالة</FormLabel>
                <Select dir={'ltr'} value={shippState} onChange={e => setShippState(Number(e.target.value))} > 
       
                    {Object.keys(STATES).map((key,i)=>(                    
                      <option key={i} value={i}>{STATES[key]}</option>                   
                    ))}
  
                 </Select>   
               </FormControl>

{isAdmin() &&
               <FormControl id="chargestate" >
                <FormLabel>حالة التوريد</FormLabel>
                <Select dir={'ltr'} value={chargeState} onChange={e => setChargeState(Number(e.target.value))} > 
       
                    {Object.keys(CHARGE_STATES).map((key,i)=>(                    
                      <option key={i} value={i}>{CHARGE_STATES[key]}</option>                   
                    ))}
  
                 </Select>   
               </FormControl>
  }
               <FormControl id="excnotes" isRequired>
                <FormLabel>ملاحظات التنفيذ</FormLabel>
                <Input type={'text'}  value={execNotes} onChange={e => setExcNotes(e.target.value)}/>
              </FormControl>
              
              <FormControl id="captin">
                <FormLabel>الكابتن</FormLabel>
                <Select isDisabled={isCaptin()} dir={'ltr'} value={captinId} onChange={e => setCaptinId(e.target.value)} > 
               {captins.map((captin,index)=>(
               
                <option  key={index} value={captin.id} >{captin.name}</option>
                
               ))}                          
                 </Select>   
                </FormControl>

                <FormControl id="excdate" >
                <FormLabel>تاريخ الإجراء</FormLabel>
                <Input type="date"  max={new Date().toISOString().split('T')[0]} value={new Date(excDate).toISOString().split('T')[0]}  onChange={e => onChangeDate(e.target.value)} />
              </FormControl>

              <Stack spacing={10} pt={2}>
                <Button
                type='submit'               
                  loadingText="Submitting"
                  size="lg"
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}>
                  تحديث
                </Button>
              </Stack>
              
              {resOk && 
              <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CheckCircleIcon boxSize={'20px'} color={'green.500'} />                           
                <Text color="green">تم تحديث الشجنة بنجاح</Text>               
              </Stack>             
              }

              {!!error &&
               <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CloseIcon boxSize={'20px'} color={'white'} />
               <Text color="red.700">{error}</Text>             
               </Stack>
               }
               
            </Stack>
            {busy &&  
          <Stack pt={4}>
            <Spinner  alignSelf={'center'} />
            </Stack>
            }
          </Box>
        </Stack>
      </Flex>
      </fieldset>
      </form>
    );
  }


